import { useState } from "react";
import { useAuthContext } from "../../contexts/AuthContext";
import { AgendaDocument, AgendaUser, UpdateAgendaDocumentMutation, UpdateAgendaDocumentMutationVariables } from "../../graphql/API";
import { getUrl } from "aws-amplify/storage";
import { useMutation } from "@apollo/client";
import { updateAgendaDocument } from "./queries";
import { useTranslation } from "react-i18next";
import { IoNavigateCircle } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import CustomModal from "../Modals/CustomModal";
import { Button, Modal } from "react-bootstrap";
import { format } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';
import Cookies from "js-cookie";
import useDateService from "../../pages/services/DateService";
// import relativeTime from 'dayjs/plugin/relativeTime';
// import dayjs from "dayjs";
// For signed-url
import { fetchAuthSession } from "aws-amplify/auth";
import outputs from "../../graphql/amplify_outputs_prod.json";
import { S3_BUCKET_PRIVATE } from "../../config";

export async function getSignedUrl(fileKey: string) {
  const { endpoint } = outputs.custom.API.signedUrl;
  const { tokens } = await fetchAuthSession();
  const jwt = tokens?.idToken?.toString() || "";

  if (!jwt) throw new Error("JWT introuvable, impossible d'appeler l'API");

  const url = `${endpoint}?fileKey=${encodeURIComponent(fileKey)}`;

  const response = await fetch(url, {
    method: "GET", // GET pour récupérer le signed URL
    headers: {
      Authorization: `Bearer ${jwt}`,
      "Content-Type": "application/json",
    },
    mode: "cors",
    // credentials: "same-origin", // pas besoin des cookies // omit // include
    cache: "no-store",
  });

  console.log("Response status:", response.status);
  const text = await response.text();
  console.log("Response body:", text);

  try {
    const data = JSON.parse(text);
    if (data?.url) return data.url;
    throw new Error(data?.error || "Erreur inconnue");
  } catch (err) {
    throw new Error("Erreur parsing JSON: " + text);
  }
}

interface IDocumentProps {
    document: AgendaDocument; // IDocument;
    includedDetails?: boolean;
    isNew?: boolean;
    locale: string;
    user?: AgendaUser;
};

const Document = ({document, includedDetails = false, isNew = false, locale = "en", user}: IDocumentProps) => {
    // AUTH
    const {userId: AuthUserId} = useAuthContext();
    // I18N
    const { t } = useTranslation();
    const savedLang = Cookies.get('language');
    // MODAL
    const [contentModal, setContentModal] = useState(null);
    const [linkModal, setLinkModal] = useState(null);
    const [showCustomModal, setShowCustomModal] = useState(false);
    const [footerModal, setFooterModal] = useState(true);
    // NAVIGATOION
    const navigate = useNavigate();
    // DATE SERVICES
    const {getTIMEZONE} = useDateService();
    // HOME SETTINGS
    const TIMEZONE = getTIMEZONE();
    
    const [doDeleteDocument] = useMutation<UpdateAgendaDocumentMutation, UpdateAgendaDocumentMutationVariables>(updateAgendaDocument, {refetchQueries: ['docsByUser']});

    const deleteDocument = () => {
        setFooterModal(false);
        setContentModal(<>
        <Modal.Header closeButton>
            <Modal.Title>{t('document.areYouSure')}</Modal.Title>
            </Modal.Header>
        
            <Modal.Body>
                <p>{t('document.deleteMessage')}</p></Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
                {t('shift.cancel')}
                </Button>
                <Button variant="primary" onClick={onDeleteDocument}>
                {t('shift.confirm')}
                </Button>
            </Modal.Footer>
        </>);
        setShowCustomModal(true);
        // Alert.alert("Are you sure?", "Do you really want to delete this document", [
        //     {
        //       text: "Cancel",
        //       style: 'cancel',
        //     },
        //     {
        //       text: "Delete",
        //       style: 'destructive',
        //       onPress: onDeleteDocument,
        //     },
        //   ]
        // );
    };

    const truncate = (str: string | undefined, maxlength: number) => {
        if (str) {
          return (str.length > maxlength) ?
          str.slice(0, maxlength - 1) + '…' : str;
        } else {
          return str;
        }
    };

    const getDocumentUrl = async (doc: any) => {
        // access denied without signed-url
        // const s3path = `${S3_BUCKET_PRIVATE}${document.comId}/${document.userId}/documents/`;
        const s3path = `private/${document.comId}/${document.userId}/documents/`;
        // console.log(path + doc.name);
        return s3path + doc.name;
    };

    const goToLink = async () => {
        // access denied without signed-url
        // const uri = await getDocumentUrl(document);
        // window.open(uri, '_blank');
        const uri = await getDocumentUrl(document);
        const signed_url = await getSignedUrl(uri);
        if (signed_url) {
            window.open(signed_url, '_blank');
        }
    };


    // const onDeleteDocument = async () => {
    //     try {
    //         await doDeleePost({
    //             variables: {
    //                 input: {
    //                     docId: document.docId,
    //                     deleted: true,         
    //                 },
    //             },
    //         });
    //     } catch(error) {
    //         alert("Error Deleting a document: " + (error as Error).message);
    //     };
    // };
    const onDeleteDocument = async () => {
        if (!document.docId) {
          alert("Failed to fetch document, try again later");
          return;
        };
        try {
          //await doDeleteComment({variables: {input: {id: commentId}}, refetchQueries: ['CommentsByPost']});
          await doDeleteDocument({
            variables: {
              input: {
                  docId: document.docId,
                  deleted: true,         
              },
            },
          });
          // incrementNofComments(-1);
          // refetch();
          window.location.reload();
        //   navigate('/documents')
        } catch(error) {
            alert("Error Deleting a document: " + (error as Error).message);
        };
    };

    const getLanguage = () => {
        switch (savedLang) {
          case 'en':
            return enUS
          case 'fr':
            return fr
          default:
            return enUS
        }
    };

    const createdAt = new Date(document?.createdAt);
    createdAt.setHours(createdAt.getHours() - TIMEZONE);

    // console.log('doc', isNew)
    return (
        <>
            <CustomModal
                show={showCustomModal}
                onHide={() => setShowCustomModal(false)}
                link={linkModal}
                children={contentModal}
                isFooter={footerModal}
            />
            <div className="post" key={"doc_"+ document?.docId}>
                {/* <div>  */}
                    {/* <span className="shiftText username">{truncate(post?.username, 20)}</span> */}
                    <span className="shiftText username">{truncate(document.name ?? undefined, 20)}</span>
                    {(user && user.type === "MANAGER") &&
                        <p className="shiftText usernameWorker">
                            <Link to={`${t('link.user')}/${document.userId}`}>
                                {truncate(document.user.username ?? undefined, 20)}
                            </Link>
                        </p>
                    }
                    <p className="shiftText">{truncate(document.type ?? undefined, 40)}</p>
                    <Link to={{}} onClick={goToLink} >
                        <IoNavigateCircle size={40} className="usersPost_icon" />
                    </Link>
                
                    { includedDetails &&
                        <div className="post_footer">
                            {isNew && (<span className="new">{t('shift.new')}</span>)}
                            <p className="post_textFooter" style={{marginTop: 20}}>{t('post.createdAt')}{format(createdAt, locale === "en" ? 'MMM d yyyy, h:mm a' : 'd MMM yyyy, h:mm a', {locale: getLanguage()})}</p>
                            {document.userId == AuthUserId ?
                                <div className="deleteWrapper">
                                    <Link to={{}} className="deleteButton" onClick={deleteDocument} style={{}}>{t('post.delete')}</Link>
                                </div>
                            :
                             (user && user.type === "MANAGER") &&
                                <div className="deleteWrapper">
                                    <Link to={{}} className="deleteButton" onClick={deleteDocument} style={{}}>{t('post.delete')}</Link>
                                </div>
                            }
                        </div>
                    }
                {/* </div> */}
            </div>
        </>
    );
};

export default Document;